import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AdminGetEmailOtcResponse extends BackendResponse {
  item: string;
}
export interface AdminGetEmailOtcParameters extends NextApiParams {}

export const adminGetEmailOtc = withNextApi<
  AdminGetEmailOtcResponse,
  AdminGetEmailOtcParameters
>("/cvp/CvpAdminGetEmailOtc", { method: "GET" });
